import { Card } from "@/components/ui/card";
import { QueueHeader } from "./QueueHeader";
import { QueueStats } from "./QueueStats";
import { QueueActions } from "./QueueActions";
import { Queue } from "@/types/queue";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { QueueStatisticsChart } from "./QueueStatisticsChart";

interface QueueDetailCardProps {
  queue: Queue;
  onNext: () => void;
  onShowQR: () => void;
}

export const QueueDetailCard = ({ queue, onNext, onShowQR }: QueueDetailCardProps) => {
  return (
    <Card className="overflow-hidden bg-card shadow-xl border-none">
      <div className="relative p-8 space-y-8">
        <div className="absolute inset-0 bg-grid-primary/10" />
        <div className="relative">
          <QueueHeader queue={queue} />
          <QueueStats queue={queue} />
          {!queue.is_active ? (
            <Alert variant="destructive" className="mt-6">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                This queue is currently inactive and cannot process new tickets
              </AlertDescription>
            </Alert>
          ) : (
            <QueueActions queue={queue} onNext={onNext} onShowQR={onShowQR} />
          )}
          <div className="mt-8">
            <QueueStatisticsChart queueId={queue.id} />
          </div>
        </div>
      </div>
    </Card>
  );
};